import moment from 'moment'

export const pricify = (raw: number): string => {
  return `€${raw.toFixed(2).replace('.', ',')}`
}

export const toItalianDate = (date: string | null): string => {
  return date ? moment(date.split(' ')[0]).format('DD/MM/YYYY') : ''
}
